export enum AuthActionType {
    SIGN_IN = "sign_in",
    SIGN_OUT = "sign_out",
    REFRESH = "refresh"
}